import { WaterBalanceSoilType } from '../waterBalance';
import mockedRequester from './mockedRequester';
export const mockedWaterBalanceConfig = {
    plotId: 3,
    soilType: WaterBalanceSoilType.sandyClay,
    availableWaterCapacity: 2
};
const mockedHyd = {
    '1612961728': 9,
    '1612961729': 10
};
const mockedAvailableWaterCapacityPerSoilType = {
    Argile: 1.75,
    'Argile limoneuse': 1.8,
    'Argile sableux': 1.7,
    'Limon argileux': 1.95,
    'Limon argileux sableux': 1.75,
    'Limon moyen': 1.8,
    'Limon moyen sableux': 1.6,
    'Limon sableux': 1.5,
    'Limon sableux argileux': 1.7,
    'Sable Limoneux': 1.1,
    'Sable argileux': 1.35
};
export const mockedWaterBalanceResult = {
    data: {
        HYD: mockedHyd,
        HYD_LVL_1: mockedHyd,
        HYD_LVL_2: mockedHyd,
        DEFI_MAX: mockedHyd
    },
    stages: {
        0: '1613520000',
        1: '1613606400'
    }
};
const mock = {
    configure: mockedRequester(mockedWaterBalanceConfig, 'waterBalance.configure'),
    getConfig: mockedRequester(mockedWaterBalanceConfig, 'waterBalance.getConfig'),
    result: mockedRequester(mockedWaterBalanceResult, 'waterBalance.result'),
    getAvailableWaterCapacityPerSoilType: mockedRequester(mockedAvailableWaterCapacityPerSoilType, 'waterBalance.getAvailableWaterCapacityPerSoilType'),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    export: mockedRequester(new Blob(), 'waterBalance.export')
};
export default mock;
